import { Box } from 'theme-ui'
import TinyArrowDown from '../../icons/TinyArrowDown'
import TinyArrowUp from '../../icons/TinyArrowUp'

export default function GridHeader({ onSort, order, ascending }) {
    const icon = (
        <Box sx={{ display: 'inline-flex' }}>
            {ascending ? <TinyArrowDown /> : <TinyArrowUp />}
        </Box>
    )

    return (
        <>
            <Box
                data-tip="hello world"
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    textAlign: 'center',
                    py: 3,
                    cursor: 'pointer',
                }}
                onClick={() => onSort('ranking')}
            >
                ✺ {order === 'ranking' && icon}
            </Box>
            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    pl: 2,
                    py: 3,
                }}
            >
                Address
            </Box>
            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    py: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => onSort('discord')}
            >
                Discord {order === 'discord' && icon}
            </Box>
            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    py: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => onSort('owns')}
            >
                Owned {order === 'owns' && icon}
            </Box>

            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    py: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => onSort('avg_listed')}
            >
                Avg Listed {order === 'avg_listed' && icon}
            </Box>
            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    py: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => onSort('gainloss')}
            >
                Gain/Loss {order === 'gainloss' && icon}
            </Box>
            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    py: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => onSort('spend')}
            >
                Spend {order === 'spend' && icon}
            </Box>
            <Box
                sx={{
                    fontSize: 3,
                    fontFamily: 'heading',
                    bg: 'background',
                    py: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => onSort('value')}
            >
                Value {order === 'value' && icon}
            </Box>
        </>
    )
}
